export default function About({ theme }) {
  return (
    <>
      <h1>Welcome!</h1>
      <div class="divider"></div>
      <div>
        <img
          src="/images/jolanta.png"
          alt="Jolanta Hildebrandt-Mazurek"
          style={{
            float: "left",
            width: "200px",
            marginTop: "30px",
            marginRight: "20px",
            marginBottom: "10px",
          }}
        />
        <p>
          Welcome to Polish-Australian poet Jolanta Hildebrandt-Mazurek's world
          where language bridges continents and experiences. Born in Poland and
          shaped by life in Australia, her poetry is a gentle exploration of
          memory, identity, and the quiet moments that define us.
          <br />
          Through her work, cultures meet, landscapes intertwine, and emotions
          find their voice in lines both tender and resonant. <br />
          Each poem is an invitation to pause, reflect, and discover the beauty
          in the everyday. <br />
          Step inside, and let the words carry you across oceans, through time,
          and into the heart of lived experience.
        </p>
        <p>
          Jolanta Hildebrandt-Mazurek was born in Poland but has spent most of
          her life in Australia. She completed her studies at the Department of
          Archaeology at the University of Sydney, then pursued a master’s
          degree at the Faculty of Education. <br />
          In her work, the poet blends the experiences of both Polish and
          Australian cultures, and her poetry has been praised by critics for
          its subtle play with language and its deep reflection on human nature,
          one's place in the world, loneliness, and the passage of time. <br />
          Her poems have been published in the cultural and literary monthly
          *Zelów* and *Gazeta Kulturalna*. She has presented her work at
          literary gatherings and PolArt poetry festivals, winning the
          appreciation of poetry enthusiasts.
          <br />
          Jolanta is a member of the Poetralia Sydney poetry club, which
          promotes poetic art and regularly organises workshops and creative
          meetings, making poetry accessible to a broader audience. As part of
          Poetralia’s activities, she also participates in the Literary Club
          meetings at the Consulate of the Republic of Poland, organised by the
          Culture Department of PACC (Polish Australian Chamber of Commerce) in
          cooperation with the University of Łódź. The program of the Literary
          Club, led by Ewelina Ellsmore (PACC) and Prof. Tomasz Cieślak (UŁ),
          promotes the Polish language and Polish literature in New South Wales.
        </p>
        <img src="/images/purpleFlower.jpg" alt="Purple Flower" />
        <p>
          Jolanta Hildebrandt-Mazurek urodziła się w Polsce, jednak większość
          życia spędziła w Australii. Ukończyła studia na Wydziale Archeologii,
          The Sydney University, następnie podjęła studia magisterskie na
          Wydziale Szkolnictwa i Edukacji. W twórczości poetka łączy
          doświadczenia obu kultur, polskiej i australijskiej, a jej poezja
          zyskała uznanie krytyków za subtelną grę językową i głęboką refleksję
          nad naturą człowieka, jego miejscem w świecie, samotnością oraz
          przemijaniem. Jej poezje ukazały się w publikacji miesięcznika
          kulturalno-literackiego Zelów, Gazeta Kulturalna. Poetka prezentowała
          swoje wiersze na spotkaniach literackich i festiwalach poetyckich
          PolArt, zdobywając sympatię miłośników poezji. Jolanta jest członkinią
          klubu poetyckiego Poetralia Sydney, który promuje sztukę poetycką oraz
          regularnie organizuje warsztaty i spotkania twórcze, udostępniając
          poezję szerszej publiczności. W ramach działalności Poetralii poetka
          uczestniczy również w spotkaniach Klubu Literackiego w Konsulacie RP
          zorganizowanych przez Dział Kultury PACC (Polsko Australijska Izba
          Handlowa) we współpracy z Uniwersytetem Łódzkim. Program Klubu
          Literackiego, prowadzonego przez Ewelinę Ellsmore (PACC) i prof.
          Tomasza Cieślaka (UŁ), popularyzuje język polski oraz literaturę
          polską w Nowej Południowej Walii.
        </p>
        <br />
        <br />
        <center>
          <div class="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/wGGWHmR26tY?si=mXAQZ8HHRYnUFXcJ"
              allowfullscreen
            ></iframe>
          </div>
          {/* 
          <figure className="video-figure">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/wGGWHmR26tY?si=mXAQZ8HHRYnUFXcJ"
              title="Sample Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <figcaption>Poems by Jolanta - Na Obczyznie</figcaption>
          </figure> */}
        </center>
        <br />
        <br />
      </div>
    </>
  );
}
